import { applyMiddleware, compose, configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import AllReducers from "../../redux/reducers";

export const store = configureStore({reducer: AllReducers}, compose(applyMiddleware(thunk)))
